import React from 'react';
function ViewHeadline() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" })));
}
export default ViewHeadline;
